import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    const listPermissions = localStorage.getItem('Permissions');
    const JWT = localStorage.getItem('JWT');
    const Code = localStorage.getItem('Code');

    //console.log("login guard");
    if(JWT === null)
    {
      if(listPermissions === null){
        return true;
      }
      else
      {
        localStorage.clear();
        return true;
      }
    }

    else if(Code === null){
      this.router.navigate(['/security-verification']);
      return false;
    }
    else{
      this.router.navigate(['/home']);
      return false;
    }
  }
}